import ReactDOM from "react-dom";
import React from "react";
import {ToastContainer} from 'react-toastify';

export function SeatsPickerModal({ children }) {
    return ReactDOM.createPortal(
        <div className={'SeatsPicker-Modal'}>
            {children}
            <ToastContainer
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss={false}
                draggable={false}
                pauseOnHover={false}
            />
        </div>,
        document.body
    )
}